import React from 'react';
import {
    Container,
    StyledLabel,
    StyledParagraph,
} from './DetailItem.StyledComponents';
import { DetailItemProps } from './DetailItem.types';

const DetailItem: React.FC<DetailItemProps> = ({ context, value }) => {
    return (
        <Container data-testid="invoice-detail-item">
            <StyledLabel>{context}</StyledLabel>
            <StyledParagraph>{value}</StyledParagraph>
        </Container>
    );
};

export default DetailItem;
